/** 数值的显示格式。单独一个文件，免得滑块和步进器各写一份 */
export function formatNumber(value: number): string {
  if (Number.isInteger(value)) return String(value);
  return value.toFixed(2);
}
